var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('v-row',[_c('v-col',{attrs:{"cols":6,"sm":12,"lg":6}},[_c('SkillCategoriesTable'),(
          ['ADMIN', 'SUPERADMIN'].includes(_vm.current_user.role) ||
          _vm.current_user.is_admin
        )?_c('AoTypesTable',{staticClass:"mt-5"}):_vm._e()],1),_c('v-col',{attrs:{"cols":6,"sm":12,"lg":6}},[_c('SkillsTable')],1)],1),(
      ['ADMIN', 'SUPERADMIN'].includes(_vm.current_user.role) ||
      _vm.current_user.is_admin
    )?_c('v-row',[_c('v-col',{attrs:{"cols":6,"sm":12,"lg":6}},[_c('SquadTable')],1),_c('v-col',{attrs:{"cols":6,"sm":12,"lg":6}},[_c('LogoForm')],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }